<template>
  <div class="configurator">
    <Navbar :navOptions="navOptions" :activeIndex="activeSection" @scroll-to="handleNavClick" />
    <Configurator ref="configuratorRef" @options-ready="updateNavOptions" @section-visible="activeSection = $event" />
    <SummaryFooterComponent />
  </div>
</template>

<script>
import Navbar from '@/components/configurator-page/NavbarComponent.vue';
import Configurator from '@/components/configurator-page/ConfigurationComponent.vue';
import SummaryFooterComponent from '@/components/configurator-page/SummaryFooterComponent.vue';

export default {
  data() {
    return {
      navOptions: [],
      activeSection: 0
    };
  },
  components: {
    Navbar,
    Configurator,
    SummaryFooterComponent
  },
  methods: {
    handleNavClick(index) {
      this.$refs.configuratorRef.scrollToOption(index);
    },
    updateNavOptions(options) {
      this.navOptions = options;
    }
  }
}
</script>

<style lang="scss">
.configurator {
  padding-top: 70px;
  padding-bottom: 50px;
  background-color: $color-white;
  min-height: 100vh;
}
</style>